import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { Button, Form, Input, Radio, Select, Textarea, Upload } from 'tdesign-react';
import Text from '@/components/Text';
import Tip from '@/components/Tip';
import { k8sUploadConfig, validateK8sCreate, writeK8sConfig } from '@/services/resourceService';
import formRulePattern from '@/utils/formRulePattern';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

export default function CreateNew({ envId, handleNext }) {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [current, setCurrent] = useState(0);
  const [step1Data, setStep1Data] = useState({});

  const configtype = Form.useWatch('configtype', form);

  useEffect(() => {
    setCurrent(0); // 表单2也隐式重置
    form.reset({ type: 'initial' });
  }, [form]);

  const handleStep1 = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      let data;
      try {
        if (configtype === 'wj') {
          // 上传
          const formData = new FormData();
          formData.append('file', fields.file[0].raw);
          formData.append('envId', envId);
          formData.append('kubeName', fields.kubeName);
          formData.append('kubeKey', fields.kubeKey);
          const resp = await k8sUploadConfig(formData);
          // eslint-disable-next-line prefer-destructuring
          data = resp.data;
        }

        if (configtype === 'wb') {
          // 文本
          const resp = await writeK8sConfig({ ...fields, envId });
          // eslint-disable-next-line prefer-destructuring
          data = resp.data;
        }
        setCurrent(1);
        setStep1Data(data); // 备用

        setTimeout(() => {
          form2.setFieldsValue({
            ...data,
          });
          form2.reset({ fields: ['namespace', 'desc'] });
        }, 50);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  const handleStep2 = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        await validateK8sCreate({
          ...fields,
          id: step1Data.id,
        });
        handleNext({ ...step1Data, ...fields });
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Root>
      {current === 0 && (
        <Form labelWidth={160} form={form} onSubmit={handleStep1}>
          <FormContainer>
            <FormItem
              rules={[{ required: true }]}
              name='kubeName'
              label={<Tip content='K8S集群显示名称'>集群名称</Tip>}
            >
              <Input />
            </FormItem>
            <FormItem
              rules={[{ required: true, message: '必填' }, { max: 100 }, formRulePattern('name')]}
              name='kubeKey'
              label={<Tip content='用于程序使用的唯一key'>唯一key</Tip>}
            >
              <Input />
            </FormItem>
            <FormItem label='配置方式' name='configtype' initialData='wj'>
              <Radio.Group size='small'>
                <Radio.Button value='wj'>文件</Radio.Button>
                <Radio.Button value='wb'>文本</Radio.Button>
              </Radio.Group>
            </FormItem>
            {configtype === 'wj' && (
              <FormItem name='file' label='config文件' rules={[{ required: true }]}>
                <Upload theme='file' autoUpload={false} />
              </FormItem>
            )}
            {configtype === 'wb' && (
              <FormItem
                rules={[{ required: true }]}
                name='kubeConfig'
                label={
                  <Tip content='kubeconfig配置文件内容，配置文件在$HOME/.kube的config文件中'>
                    config文本
                  </Tip>
                }
              >
                <Textarea />
              </FormItem>
            )}
          </FormContainer>
          <Footer>
            <Button loading={submitting} onClick={() => form.submit()}>
              下一步
            </Button>
          </Footer>
        </Form>
      )}
      {current === 1 && (
        <Form labelWidth={160} form={form2} onSubmit={handleStep2}>
          <FormContainer>
            <FormItem
              name='serviceUrl'
              label={<Tip content='从config文件中自动解析'>Service_URL</Tip>}
            >
              <Text />
            </FormItem>
            {isEmpty(step1Data.contextList) ? (
              <FormItem name='context' label={<Tip content='从config文件中自动解析'>Context</Tip>}>
                <Text />
              </FormItem>
            ) : (
              <FormItem
                name='context'
                rules={[{ required: true }]}
                label={<Tip content='从config文件中自动解析'>选择Context</Tip>}
              >
                <Select
                  options={toTsOptions(
                    step1Data.contextList.map((item) => ({
                      value: item,
                      label: item,
                    })),
                  )}
                />
              </FormItem>
            )}
            <FormItem
              name='configClusterName'
              label={<Tip content='从config文件中自动解析'>集群名称</Tip>}
            >
              <Text />
            </FormItem>
            <FormItem name='ip' label={<Tip content='用于执行kubectl命令的主机地址'>主机地址</Tip>}>
              <Text />
            </FormItem>
            <FormItem
              rules={[{ required: true }]}
              name='namespace'
              label={<Tip content='选用于部署Operator的Namespace'>namespace</Tip>}
            >
              <Input />
            </FormItem>
            <FormItem rules={[{ required: true }]} name='desc' label='备注信息'>
              <Textarea />
            </FormItem>
          </FormContainer>
          <Footer>
            <Button loading={submitting} onClick={() => form2.submit()}>
              下一步
            </Button>
          </Footer>
        </Form>
      )}
    </Root>
  );
}

const Root = styled.div``;

const FormContainer = styled.div`
  width: 80%;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
`;
